var FocusWithin = (function() {
    'use strict'

    var _removeFocusAttr = function(elem) {
        elem.removeAttribute('data-focus-within');
    }

    var update = function() {
        // remove all attributes of current focused tree
        [].slice.call(document.querySelectorAll('[data-focus-within]')).forEach(_removeFocusAttr);

        var element = document.activeElement;

        while(element && typeof element.classList != 'undefined') {
            element.setAttribute('data-focus-within', '');
            element = element.parentNode;
        }
    }

    var init = function() {
        document.addEventListener('focus', FocusWithin.update, true);
        document.addEventListener('blur', FocusWithin.update, true);
        update();
    }

    return {
        init: init,
        update: update,
    }
})();
